export const DEVELOPMENT = 'development'
export const STAGING = 'staging'
export const PRODUCTION = 'production'
export const DEV_ABBR = 'dev'
export const STG_ABBR = 'stg'
export const PROD_ABBR = 'prod'
